module.exports = __webpack_public_path__ + "static/media/image-card-2.ae4e5db5.png";